/**
 * Api Documentation
 * Api Documentation
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { SubmissionKeyValueDataRequest } from './submissionKeyValueDataRequest';


export interface SubmissionComponentDataRequest { 
    /**
     * The component's uuid
     */
    uuidComponent: string;
    /**
     * The values list
     */
    values: Array<SubmissionKeyValueDataRequest>;
}
